module.exports = __webpack_public_path__ + "img/edit_structure.1cc1fc6.png";